<template>
  <div class="answers_multichoice">
    <div
      v-for="(item, i) in data"
      :key="i"
      class="answer"
      :class="{'has-other': item.type === 'other' && selected_ids.indexOf(item.id) > -1}"
    >
      <vchecklabel 
        :class="['answer__check', {
          'answer__check_other': item.type === 'other'
        }]"
        :value="selected_ids.indexOf(item.id) > -1"
        :label="item.content"
        @input="set_selected_ids($event, item)"
      />
      <vtextarea
        v-if="item.type === 'other' && selected_ids.indexOf(item.id) > -1"
        :value="other_val"
        :height="120"
        :placeholder="$tr('interview.tests.all.questions.answers.answer.value')"
        @input="set_input($event, item)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'answers_multichoice',
  props: ['data', 'id'],
  data() {
    return {
      selected_ids: [],
      other_val: null
    }
  },
  watch: {
    valid(v) {
      this.$emit('set_valid_date', v);
    }
  },

  computed: {
    valid() {
      if(!this.otherId || !this.selected_ids || !this.selected_ids.find(item => item === this.otherId)) {
        return true;
      }

      return !!this.other_val; 
    },
    otherId() {
      if (!this.data || !this.data.length) {
        return 0;
      }
      const otherItem = this.data.find(item => item.type === 'other');

      if (!otherItem) {
        return 0;
      }

      return otherItem.id;
    }
  },
  methods: {
    set_selected_ids(v, item) {
      let result = [];
      if(v) {
        this.selected_ids.push(item.id);
      } else {
        let p = this.selected_ids.indexOf(item.id);
        this.selected_ids.splice(p, 1);
      }
      this.selected_ids.forEach(i => {
        result.push(i);
      })

      let obj = {
        question_id: this.id,
        answers: result
      }
      if((v && this.other_val && item.type === 'other') ||
        (item.type !== 'other' && !!this.selected_ids.find(item => item === this.otherId))) {
        obj.other = this.other_val;
        let p = obj.answers.indexOf(item.id);
        if (p) {
          obj.answers.splice(p, 1);
        }
      }
      this.$emit('update', obj);
    },

    updateOtherItem(item) {
      let obj = {
        question_id: this.id,
        answers: [...this.selected_ids]
      }
      if(item.type === 'other') {
        obj.other = this.other_val;
        let p = obj.answers.indexOf(item.id);
        if (p !== -1) {
          obj.answers.splice(p, 1);
        }
      }
      this.$emit('update', obj);
    },

    set_input(v, item) {
      if(this.selected_ids.indexOf(item.id) === -1) {
        this.selected_ids.push(item.id);
      }
      this.other_val = v;
      this.updateOtherItem(item);
    }
  }
}
</script>

<style lang='scss' scoped>
.answers_multichoice {
  .answer {
    display: flex;
    margin-bottom: 8px;
    
    @media (max-width: 460px) {
      margin-bottom: 0;
    }

    &.has-other {
      flex-direction: column;  
    }

    ::v-deep .vtextarea {
      margin-top: 11px;
      margin-left: 10px;
      margin-right: 4px;

      .textarea {
        padding: 13px 20px;
      }
    }
  }
  .answer__check {
    cursor: pointer;
    
    &_input {
      width: calc(100% - 10px);
      margin-top: 15px;
      margin-left: 10px;
    }
  }
}
</style>